// 直播讨论 / 弹幕合集 / 锐评 / 反应视频 内容数据

export const siteMeta = {
  name: "99吃瓜",
  slogan: "全网热点，蹲在现场一起看",
  desc: "99吃瓜直播讨论社区：连麦现场、弹幕合集、主播锐评与全网反应视频一站式聚合，热门话题一出就有人开播陪看。",
};

export interface LiveStream {
  id: string;
  title: string;
  streamer: string;
  category: string;
  viewers: number;
  heat: string;
  image: string;
}

export const liveCategories = ["全部", "连麦现场", "陪看直播", "影视切片", "电竞名场"];

export const liveStreams: LiveStream[] = [
  {
    id: "live-1",
    title: "综艺名场面全流程陪看",
    streamer: "瓜田老刘",
    category: "陪看直播",
    viewers: 12300,
    heat: "98.7万",
    image:
      "https://readdy.ai/api/search-image?query=vibrant%20stylized%20livestream%20co-watching%20scene%20with%20colorful%20character%20avatars%20crowded%20around%20a%20glowing%20screen%20in%20a%20dark%20room%2C%20warm%20orange%20neon%20rim%20lighting%2C%20energetic%20reaction%20mood%2C%20cinematic%20illustration%2C%20deep%20charcoal%20tones%20with%20ember%20particles&width=720&height=405&seq=live-01&orientation=landscape",
  },
  {
    id: "live-2",
    title: "深夜连麦：这波回应你怎么看",
    streamer: "连麦阿Ken",
    category: "连麦现场",
    viewers: 8600,
    heat: "65.2万",
    image:
      "https://readdy.ai/api/search-image?query=late%20night%20live%20audio%20discussion%20room%20scene%20with%20two%20silhouette%20hosts%20chatting%20across%20a%20minimal%20desk%2C%20cozy%20amber%20table%20lamp%20glow%2C%20dark%20warm%20background%2C%20cinematic%20illustration%2C%20gossip%20talk%20atmosphere%2C%20soft%20focus%20depth&width=720&height=405&seq=live-02&orientation=landscape",
  },
  {
    id: "live-3",
    title: "反应向切片，边看边锐评",
    streamer: "爆梗小K",
    category: "影视切片",
    viewers: 5400,
    heat: "41.8万",
    image:
      "https://readdy.ai/api/search-image?query=exciting%20clip%20reaction%20session%20scene%20with%20popcorn%20bucket%20and%20hand%20remote%20in%20foreground%20facing%20a%20warm%20glowing%20tv%20screen%2C%20dark%20living%20room%20with%20orange%20accent%20light%2C%20cinematic%20illustration%2C%20fun%20energetic%20vibe&width=720&height=405&seq=live-03&orientation=landscape",
  },
];

export interface DanmakuMoment {
  time: string;
  text: string;
  count: string;
  hot?: boolean;
}

export const danmakuMoments: DanmakuMoment[] = [
  { time: "02:14", text: "主播笑到岔气前先看了一眼弹幕，然后彻底绷不住", count: "3.2万", hot: true },
  { time: "08:47", text: "经典‘看懂了又没完全看懂’名场面，评论区开始二创", count: "2.7万", hot: true },
  { time: "15:02", text: "连麦被一句反杀，全场刷屏‘好活’", count: "1.9万" },
  { time: "21:36", text: "弹幕集体许愿，主播当场表演绝活", count: "1.4万" },
  { time: "33:05", text: "反应视频上线十分钟冲上热榜，评论区现场考古", count: "9800" },
  { time: "47:28", text: "名场面字幕错位反成经典，全网开始传播", count: "7600" },
];

export interface ReactionVideo {
  id: string;
  title: string;
  channel: string;
  views: string;
  duration: string;
  tag: string;
  image: string;
}

export const reactionVideos: ReactionVideo[] = [
  {
    id: "r-1",
    title: "第一次看这波现场，直接笑到捶桌",
    channel: "反应社",
    views: "218万",
    duration: "06:42",
    tag: "爆笑反应",
    image:
      "https://readdy.ai/api/search-image?query=person%20laughing%20hard%20while%20watching%20a%20clip%2C%20stylized%20character%20slapping%20desk%20in%20reaction%2C%20warm%20orange%20and%20amber%20lighting%2C%20dark%20studio%20background%2C%20energetic%20cinematic%20illustration%2C%20comedic%20moment%2C%20no%20text&width=720&height=405&seq=react-01&orientation=landscape",
  },
  {
    id: "r-2",
    title: "看完三遍才看懂，这波铺垫太深了",
    channel: "慢镜头观察",
    views: "167万",
    duration: "11:20",
    tag: "深度解析",
    image:
      "https://readdy.ai/api/search-image?query=focused%20person%20replaying%20a%20clip%20with%20eyes%20squinting%20in%20concentration%2C%20stylized%20illustration%20with%20magnifying%20glass%20over%20glowing%20screen%2C%20dark%20room%20amber%20accent%2C%20thoughtful%20reaction%20vibe%2C%20cinematic%20composition%2C%20no%20text&width=720&height=405&seq=react-02&orientation=landscape",
  },
  {
    id: "r-3",
    title: "带着妈妈一起看，结局谁也没想到",
    channel: "全家反应组",
    views: "132万",
    duration: "08:15",
    tag: "温情反应",
    image:
      "https://readdy.ai/api/search-image?query=family%20silhouettes%20watching%20together%20on%20couch%20under%20warm%20amber%20tv%20glow%2C%20stylized%20illustration%20dark%20living%20room%2C%20cozy%20surprised%20reaction%20moment%2C%20cinematic%20depth%2C%20soft%20orange%20lighting%2C%20no%20text&width=720&height=405&seq=react-03&orientation=landscape",
  },
];

export interface HotTopic {
  rank: number;
  title: string;
  tag: string;
  heat: string;
  delta: "up" | "down" | "new" | "keep";
}

export const hotTopics: HotTopic[] = [
  { rank: 1, title: "新剧开播首播日冲上热搜，弹幕瞬间刷屏", tag: "热播陪看", heat: "512万", delta: "up" },
  { rank: 2, title: "综艺即兴名场面，观众纷纷表示要反复回看", tag: "名场面", heat: "398万", delta: "new" },
  { rank: 3, title: "主播直播连麦翻车瞬间，全网开始考古", tag: "连麦现场", heat: "287万", delta: "up" },
  { rank: 4, title: "爆款反应视频十小时破百万，评论区二创井喷", tag: "反应视频", heat: "241万", delta: "keep" },
  { rank: 5, title: "深夜电台式连麦被刷屏，聊到三点还在加更", tag: "深夜连麦", heat: "198万", delta: "up" },
  { rank: 6, title: "弹幕集体许愿成真，主播当场兑现绝活", tag: "弹幕爆梗", heat: "156万", delta: "down" },
  { rank: 7, title: "电竞名场面回放，解说全程高能输出", tag: "电竞名场", heat: "112万", delta: "new" },
];

export interface ReviewItem {
  streamer: string;
  quote: string;
  tag: string;
}

export const reviews: ReviewItem[] = [
  {
    streamer: "瓜田老刘",
    quote: "这一段我看三遍了，第一次看乐，第二次看细节，第三次才看懂铺垫，真够能藏的。",
    tag: "锐评·陪看",
  },
  {
    streamer: "连麦阿Ken",
    quote: "遇到这种回应别急着站队，先听完整段，很多反转都在最后一句里。",
    tag: "锐评·连麦",
  },
  {
    streamer: "爆梗小K",
    quote: "弹幕才是永远的主场，画面没接住的梗，评论一个不落全给圆回来了。",
    tag: "锐评·弹幕",
  },
  {
    streamer: "慢镜头观察",
    quote: "真正的好戏不在表面的热闹，在没人注意的三十秒里。",
    tag: "锐评·解析",
  },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqs: FaqItem[] = [
  {
    q: "99吃瓜是什么？",
    a: "99吃瓜是一个面向全网热点的直播讨论社区，聚合了连麦现场、弹幕合集、主播锐评和反应视频。热门话题一出现，就能找到陪看直播和全网反应，像蹲在现场一样实时追热点。",
  },
  {
    q: "在这里能看到哪些内容？",
    a: "主要覆盖四大类：正在直播的陪看与连麦现场、高能弹幕与名场面合集、主播对热点的一手锐评，以及网友产出的各类反应视频。每个板块都围绕当下讨论度最高的话题更新。",
  },
  {
    q: "内容多久更新一次？",
    a: "话题型内容基本实时刷新，陪看直播开播即上榜；弹幕合集与反应视频通常在一波热点发酵后的数小时内完成整理，确保你看到时讨论还热乎。",
  },
  {
    q: "需要登录才能浏览吗？",
    a: "浏览绝大多数内容无需登录，直接即可查看直播、弹幕和反应视频。登录后可以收藏话题、参与弹幕互动并在评论区发言，体验更完整。",
  },
  {
    q: "如何参与弹幕或连麦互动？",
    a: "进入正在直播的陪看现场，即可发送弹幕参与刷屏；部分直播间开放连麦申请，排队通过后就能上麦表达观点，与主播和其他观众实时对线。",
  },
  {
    q: "发现内容不合适或涉及剧透怎么办？",
    a: "可以通过每张卡片上的反馈入口提交。我们的内容审核团队会及时处理，涉及剧透、引战或侵权的内容会优先下架，并在页面内给出提示。",
  },
];

export const searchPool = [
  ...liveStreams.map((s) => ({ key: s.id, title: s.title, type: "直播" })),
  ...reactionVideos.map((r) => ({ key: r.id, title: r.title, type: "反应视频" })),
  ...hotTopics.map((t) => ({ key: `h${t.rank}`, title: t.title, type: "热议" })),
];